import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/commerce-pwa-studio/commerce-pwa-studio/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p><strong parentName="p">{`Properties`}</strong></p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`shouldPrefetch`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`bool`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`true`}</inlineCode>{` activates prefetching the target page when the link becomes visible in the viewport.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`to`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`From `}<a parentName="td" {...{
              "href": "https://knowbody.github.io/react-router-docs/api/Link.html"
            }}>{`react-router-dom Link`}</a>{`. The absolute path to the target page of the link. Uses the `}<inlineCode parentName="td">{`to`}</inlineCode>{` prop from the `}<inlineCode parentName="td">{`react-router-dom Link`}</inlineCode>{`.`}</td>
        </tr>
      </tbody>
    </table>
    <p><strong parentName="p">{`Example`}</strong>{` `}<em parentName="p">{`(Basic usage)`}</em>{`  `}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`<Link shouldPrefetch={true} to="/about/">About Us</Link>
`}</code></pre>
    <p><strong parentName="p">{`Properties`}</strong></p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Default`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`[prefetchType]`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`bool`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode>{`false`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Deprecated. Use `}<inlineCode parentName="td">{`shouldPrefetch`}</inlineCode>{` instead.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`[shouldPrefetch]`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`bool`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode>{`false`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Determine if the link should be prefetched using `}<inlineCode parentName="td">{`IntersectionObserver`}</inlineCode>{`.`}</td>
        </tr>
      </tbody>
    </table>
    <p><strong parentName="p">{`Source Code`}</strong>{`: `}<a parentName="p" {...{
        "href": "https://github.com/magento/pwa-studio/blob/develop/packages/venia-ui/lib/components/Link/link.js"
      }}>{`pwa-studio/packages/venia-ui/lib/components/Link/link.js`}</a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      